export default "__VITE_ASSET__7ce9ae9c__"